import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'field', 'text' ]

  toggleField(event) {
    event.preventDefault();

    this.fieldTarget.classList.toggle('hidden');
    this.textTarget.classList.toggle('hidden');
  }
}